import { gspx } from '@rsos/capstone';

const EVENT_CATEGORY = 'Avive AED';
const EVENT_NAME = 'Avive AED';

/**
 * Tracks successful AED search requests.
 */
export const trackSearched = () => {
  return gspx.trackCustomEvent(EVENT_NAME, {
    name: 'AED launched',
    Category: EVENT_CATEGORY,
  });
};

/**
 * Tracks clicks on the "Current Location" button in AviveSearchForm.
 */
export const trackCurrentLocationClicked = () => {
  return gspx.trackCustomEvent(EVENT_NAME, {
    name: 'Current Location clicked',
    Category: EVENT_CATEGORY,
  });
};

/**
 * Tracks when a note has been updated.
 */
export const trackNoteUpdated = () => {
  return gspx.trackCustomEvent(EVENT_NAME, {
    name: 'Note updated',
    Category: EVENT_CATEGORY,
  });
};

/**
 * Tracks successful AED search cancellations.
 */
export const trackCanceled = () => {
  return gspx.trackCustomEvent(EVENT_NAME, {
    name: 'AED canceled',
    Category: EVENT_CATEGORY,
  });
};

/**
 * Tracks successful searches using location coordinates.
 */
export const trackOptionSearchByLocation = () => {
  return gspx.trackCustomEvent(EVENT_NAME, {
    name: 'AED launched by location',
    Category: EVENT_CATEGORY,
  });
};

/**
 * Tracks searches that timeout.
 */
export const trackTimeout = () => {
  return gspx.trackCustomEvent(EVENT_NAME, {
    name: 'AED timeout',
    Category: EVENT_CATEGORY,
  });
};
